import { useProperty, useSnowplowTracking, useTranslation } from '@eti/providers';
import { Heading, Stack, Text, textVariants } from '@etg/wings';
import { Link } from 'react-router-dom';
import { PartOfExternalFlights } from '@eti/schema-types';
import TopicsContentWrapper from '../TopicsContentWrapper';
import { routes } from '../../../../../constants/routesAndApisConstants';
import CardWithActionButton from '../../common/CardWithActionButton';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import FaqSection from '../../common/FaqSection';
import ContactRyanairContent from './ContactRyanairContent';

const CheckInInfo = () => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();
  const { isVI, partOfExternalFlights, shouldShowManageTrip, faqSectionPerSlug } =
    useOrderDetails();
  const faqSectionSlug = p('ContactUs.CheckInInfo.Faq.Slug');

  if (partOfExternalFlights === PartOfExternalFlights.All) {
    return <ContactRyanairContent faqSectionSlug={faqSectionSlug} />;
  }

  const handleOnCardButtonClick = () => {
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({
        category: 'Contact',
        action: 'Click',
        label: 'CHECK_IN_DETAILS',
        property: 'CHECK_IN',
      });
    }
  };

  const checkInDescription = isVI
    ? t('OrderDetails.CheckIn.NotPurchased.VI.Description')
    : t('OrderDetails.CheckIn.NotPurchased.Description');

  return (
    <TopicsContentWrapper
      chatType="oriana"
      leftColumnContent={
        <Stack spacing={24}>
          <Stack spacing={8}>
            <Text variant={textVariants._16_BOLD}>
              {t('OrderDetails.CheckIn.NotPurchased.Title')}
            </Text>
            <Text asHtml>{checkInDescription}</Text>
          </Stack>
          <Stack spacing={8}>
            <Text variant={textVariants._16_BOLD}>
              {t('OrderDetails.CheckIn.BoardingPasses.Title')}
            </Text>
            <Text>{t('OrderDetails.CheckIn.BoardingPasses.Description')}</Text>
          </Stack>
          {faqSectionPerSlug?.[faqSectionSlug] && (
            <FaqSection
              headingAs="h5"
              headingLevel={4}
              padding={0}
              section={faqSectionPerSlug[faqSectionSlug]}
            />
          )}
        </Stack>
      }
      rightColumnContent={
        shouldShowManageTrip && (
          <CardWithActionButton
            as={Link}
            buttonText={t('ContactUs.Subtopic.CheckInInfo.Banner.Button.Text')}
            onClick={handleOnCardButtonClick}
            to={routes.ORDER_DETAILS_CHECK_IN}
          >
            <Stack spacing={8}>
              <Heading as="h5" level={3}>
                {t('ContactUs.Subtopic.CheckInInfo.Banner.Title')}
              </Heading>
              <Text>{t('ContactUs.Subtopic.CheckInInfo.Banner.Content')}</Text>
            </Stack>
          </CardWithActionButton>
        )
      }
      snowplowProperty="CHECK_IN"
    />
  );
};

export default CheckInInfo;
